// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const TinyChevronBottom_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm20.03 9.53-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 15.44l6.97-6.97a.75.75 0 0 1 1.06 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'TinyChevronBottom_Stroke2_Corner0_Rounded',
})
